import { render } from "./Release.vue?vue&type=template&id=fe4d4cb4&scoped=true"
import script from "./Release.vue?vue&type=script&lang=js"
export * from "./Release.vue?vue&type=script&lang=js"

import "./Release.vue?vue&type=style&index=0&id=fe4d4cb4&scoped=true&lang=css"

import exportComponent from "D:\\genx_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4d4cb4"]])

export default __exports__